import { modelEncodingEnum } from "../../shared/enums/metaKeys"
import { ThreeDModelProps } from "./Schema.config"

const ThreeDModelMetaScript = ({ image, model, name, format }: ThreeDModelProps) => {

    return (
        <script type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: `{ "@context": "https://schema.org/", "@type": "3DModel", "image": "${image}", "name": "${name}", "encoding": [{ "@type": "MediaObject", "contentUrl": "${model}", "encodingFormat": "${modelEncodingEnum[format]}" }] }`
            }}
        >
        </script>
    )
}

export default ThreeDModelMetaScript